import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

// sp 100vh adjustment
jQuery(function ($) {
  $(window).on('load resize', function () {
    let vh = document.documentElement.clientHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  });
});

gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function () {

  ScrollTrigger.create({
    trigger: '.js-fixed-contact-trigger',
    // endTrigger: '.js-header-end',
    start: 'top center',
    end: 'bottom center',
    // markers: true,
    toggleClass: {
      targets: ".js-fixed-contact",
      className: "is-on"
    },
  });

  ScrollTrigger.create({
    trigger: '.js-fixed-nav-trigger',
    // endTrigger: '.js-header-end',
    start: 'top top',
    end: '110% top',
    // markers: true,
    toggleClass: {
      targets: ".js-fixed-nav",
      className: "is-wht"
    },
  });

});
